module.exports = __webpack_public_path__ + "assets/img/E.b0a228eb.png";